import React, { useEffect, useRef } from 'react';
import lodashDebounce from 'lodash/debounce';
import { func, number, string } from 'prop-types';

import exportWithBoundary from '../../../helpers/exportWithBoundary';
import {
  QuickSearchContainer,
  QuickSearchIcon,
  QuickSearchInput,
} from './styles';

function QuickSearch({
  initialValue,
  onChange,
  onChangeDelay,
  placeholder,
  className,
}) {
  const inputRef = useRef(null);

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = initialValue || '';
    }
  }, [initialValue, inputRef]);

  return (
    <QuickSearchContainer
      className={className}
      hasValue={inputRef.current && inputRef.current.value.length > 0}
    >
      <QuickSearchInput
        ref={inputRef}
        data-test='input-quick-search'
        onChange={lodashDebounce((event) => handleChange(event), onChangeDelay)}
        onKeyUp={(event) => {
          if (event.key === 'Enter') {
            handleChange(event);
          }
        }}
        placeholder={placeholder}
      />
      <QuickSearchIcon
        className='icon-close icon--20'
        onClick={(event) => {
          inputRef.current.value = '';
          handleChange(event);
        }}
      />
    </QuickSearchContainer>
  );
}

QuickSearch.propTypes = {
  initialValue: string,
  onChange: func.isRequired,
  onChangeDelay: number,
  placeholder: string,
  className: string,
};

QuickSearch.defaultProps = {
  initialValue: '',
  placeholder: null,
  onChangeDelay: 1000,
  className: '',
};

function QuickSearchFallback() {
  return <span />;
}

export default exportWithBoundary(QuickSearch, QuickSearchFallback);
